import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestGetFeedDto, RequestSetStatusFeedDto, RequestEditStatusFeedDto } from '../dto/feed-service.dto';

@Injectable()
export class FeedServiceNestApi {

	private service: string = '';
	private model: string = 'feedservice';

	constructor(
		public nestApiProvider: NestApiProvider,
	) {
	}

	public getFeed(payload: RequestGetFeedDto): Observable<any> {
		const method: string = 'GET';
		const func: string = 'getFeed';
		const params: any = {};
		const urlParams: any = payload || {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body, null, null, null, false);
	}

	public setStatusFeed(payload: RequestSetStatusFeedDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'setStatusFeed';
		const params: any = payload || {};
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public editStatusFeed(payload: RequestEditStatusFeedDto): Observable<any> {
		const method: string = 'POST';
		const func: string = 'editStatusFeed';
		const params: any = payload || {};
		const urlParams: any = {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

	public getStatusFeed(payload: { feedId: number }): Observable<any> {
		const method: string = 'GET';
		const func: string = 'getStatusFeed';
		const params: any = {};
		const urlParams: any = payload || {};
		const body: any = {};

		const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
		return this.nestApiProvider.request(method, url, params, urlParams, body);
	}

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/feed-service.api.ts